
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from "store/actions/index";
import * as UiConfig from 'Flow2/components/CustomCollections/CustomDataConfig/CustomUiConfig';
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import CustomEvents from 'Flow2/components/CustomCollections/CustomDataConfig/CustomAppEvents';
import { CustomAppEventListener, isPMDB } from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController';
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import CustomWithSpinner from 'Flow2/components/CustomCollections/CustomBox/CustomWithSpinner/CustomWithSpinner';
import CustomGapiBox from 'Flow2/components/CustomCollections/CustomBox/CustomGapiBox/CustomGapiBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SweetAlert from 'sweetalert2';

const CustomGapiBoxWithSpinner = CustomWithSpinner(CustomGapiBox);
const createInputTag = (name, id, type = "text", isRequired = false) => {
    let inputBorder = "";
    if (isRequired) inputBorder = " border: 1px solid red; "
    return '<div style="margin-top: 10px;" ><label style="text-align: left; width: 90px; display: inline-block; font-size: 14px;">' + name + '</label><input style="width: 300px; color: gray; ' + inputBorder + '" type="' + type + '" id="' + id + '"></div>';
}

class ShowGapi extends Component {

    constructor(props) {
        super(props);
        this.state = {
            clientId: null,
            loading: true,
            startDate: null,
            endDate: null
        }
    }

    showUserDialog = (isRequired = false) => {
        if (!this.state.clientId || !this.props.customGoogleSignIn) {
            let lg = DataUtil.getLanguage(this.props.language);
            let html = "";
            let trackingId = UiConfig.TRACKING_ID;
            let clientId = UiConfig.CLIENT_ID;
            if (clientId === "") {
                html += '<p style="text-align:right; font-size: 12px; color: #aaaaaa; margin-right: 60px;">*Pflichtfeld</p>';
                html += createInputTag("Client-ID*", "gapi_client_id", "text", isRequired);
            }
            if (trackingId === "") html += createInputTag("Tracking-ID", "gapi_tracking_id");
            html += createInputTag("Start Date", "gapi_start_date", "date") + createInputTag("End Date", "gapi_end_date", "date");
            SweetAlert.fire({
                title: "Google Analytics",
                html: html,
                showCancelButton: true,
                showConfirmButton: true,
                cancelButtonColor: CustomTypes.COLOR_BLACK,
                confirmButtonColor: CustomTypes.COLOR_RED,
                cancelButtonText: DataUtil.translateMessageForApp("CustomMsgClose", lg),
                confirmButtonText: "Start"
            }).then(result => {
                if (result.value) {
                    if (trackingId === "") trackingId = document.getElementById("gapi_tracking_id").value;
                    if (clientId === "") clientId = document.getElementById("gapi_client_id").value;
                    if (clientId) {
                        CustomAppEventListener(CustomEvents.LOAD_SCRIPT, "gapi", trackingId);
                        if (clientId && clientId !== "") {
                            this.setState({
                                clientId: clientId,
                                startDate: document.getElementById("gapi_start_date").value,
                                endDate: document.getElementById("gapi_end_date").value
                            });
                        }
                        this.props.togglePopUpHidden();
                        setTimeout(() => {
                            this.setState({ loading: false });
                        }, 4000);
                    } else {
                        this.showUserDialog(true);
                    }
                }
            });
        } else {
            this.props.togglePopUpHidden();
        }
    }

    render() {
        if (UiConfig.showCustomAnalytics && isPMDB())
            return (
                <div>
                    <FontAwesomeIcon icon={CustomAppEventListener(CustomEvents.GET_AWE_ICON, "faLaptop")} onClick={() => this.showUserDialog()} />
                    {this.props.customPopUpHidden ?
                        <CustomGapiBoxWithSpinner
                            type="analytics"
                            clienId={this.state.clientId}
                            isLoading={this.state.loading}
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                        /> : null}
                </div>)
    }

}

const mapStateToProps = (state) => ({
    customPopUpHidden: state.customData.customPopUpHidden,
    customGoogleSignIn: state.customData.customGoogleSignIn,
    language: state.ui.language,
});

const mapDispatchToProps = (dispatch) => ({
    togglePopUpHidden: () => dispatch(actions.toggleCustomPopUpHidden())
})

export default connect(mapStateToProps, mapDispatchToProps)(ShowGapi);



